import { Component, OnInit, OnDestroy, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { interaction, geom, format } from 'openlayers';
import { MapService2 } from '../../../shared/services/maps/map2.service';

declare var $, jQuery: any;
@Component({
    moduleId: module.id,
    selector: 'draw',
    templateUrl: 'draw.component.html'
})
export class DrawInteractionComponent implements OnInit, OnDestroy {
    instance: interaction.Draw;
    load: boolean = false;
    drawingType: string = 'Circle';
    mapOptions: any;
    wktFormat: format.WKT = new format.WKT();
    drawingSource: any;
    @Input() shapeTypes: string[] = [];
    @Input() addMode: boolean = true;
    @Input() disableDelete: boolean = true;
    @Output() geofenceCreationEnd: EventEmitter<any> = new EventEmitter();
    @Output() GeofenceShapeDeleted: EventEmitter<any> = new EventEmitter();

    constructor(private _mapService: MapService2) {
        this.drawingSource = this._mapService.getGraphicSource('draw');
    }
    init() {

        this.mapOptions = { type: this.drawingType, source: this.drawingSource };
        this.instance = new interaction.Draw(this.mapOptions);
        this._mapService.addInteraction(this.instance);
        this.load = true;
        var self = this;

        // Emit Event when draw Finshed
        // Event carry object of {type,measurment,wktGeometry}
        this.instance.on("drawend", (evt) => {

            var geometryMeasure = 0;
            var geofenceType = self.drawingType;
            var geometry = evt.feature.getGeometry();

            if (geofenceType == 'Circle') {
                geometryMeasure = geometry.getRadius();
                geometry = geom.Polygon.fromCircle(geometry, 50); // 50 is Number of sides 
            }
            else if (geofenceType == 'Polygon')
                geometryMeasure = geometry.getArea();
            else
                geometryMeasure = geometry.getLength();

            var newObject = jQuery.extend(true, {}, geometry);

            var newObject = newObject.transform("EPSG:3857", "EPSG:4326");
            var wktGeometry = this.wktFormat.writeGeometry(newObject);
            self.geofenceCreationEnd.emit({ type: geofenceType, measure: geometryMeasure.toFixed(3), geometryObject: wktGeometry });
            self._mapService.removeInteraction(self.instance);
            self.load = false;
        });
    }
    draw(type: string) {
        this.drawingSource.clear();
        this.drawingType = type;
        if (!this.load)
            this.init();
        else {
            this._mapService.removeInteraction(this.instance);
            this.init();
        }
    }
    delete() {
        if (this._mapService.selectedFeaturesForEdit) {
            this._mapService.deleteFeature(this._mapService.selectedFeaturesForEdit.item(0).getId(), this._mapService.geofencesGraphicSource);
            this.addMode = true;
            this._mapService.enableEditControl(false);
            this.GeofenceShapeDeleted.emit(this._mapService.selectedFeaturesForEdit.item(0));
        }

    }
    getShapeStyle(shapeType) {
        if (shapeType == 'Circle') {
            return 'fa fa-circle-thin';
        }
        else if (shapeType == 'Polygon') {
            return 'icon icon-polygon';
        }
        else if (shapeType == 'LineString') {
            return 'fa fa-vine';
        }
        else if (shapeType == 'Point') {
            return 'fa fa-circle';
        }

    }
    ngOnInit() {
    }
    ngAfterViewInit() {

    }
    public ngOnDestroy() {
        this._mapService.removeInteraction(this.instance);
    }

    public removeDrawing() {
        this.drawingSource.clear();
        this._mapService.removeInteraction(this.instance);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/drawingComponent/draw.component.ts